export default __webpack_public_path__ + "static/media/logo.20084ae2.png";